import axios from 'axios';
import Card from 'components/Card/Card.jsx';
import moment from 'moment';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row, Badge } from 'react-bootstrap';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import { Sticky, StickyContainer } from 'react-sticky';
//Redux
import { bindActionCreators } from 'redux';
import Button from '../../components/CustomButton/CustomButton';
import auth from '../../libCustom/auth';
import feathers from '../../feathers';

//Forms
import ClientInformation from './cards/clientInformation';
import DatesQuotation from './cards/datesQuotation';
import FlightQuotation from './cards/flightQuotation';
import FlightQuotationAdd from './cards/flightQuotationAdd';
import GeneralQuotation from './cards/generalQuotation';
import LodgingQuotation from './cards/lodgingQuotation';
import LodgingQuotationAdd from './cards/lodgingQuotationAdd';
import OtherServicesQuotation from './cards/otherServicesQuotation';
import OtherServicesQuotationAdd from './cards/otherServicesQuotationAdd';
import Packages from './cards/packages';
import PackagesAdd from './cards/packagesAdd';
import * as QuotationsActions from './redux/QuotationsActions';
import ButtonSave from '../../components/ButtonSave';
import Loading from '../../components/Loading';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import SweetAlert from 'react-bootstrap-sweetalert';
moment.globalLocale = 'es';

class QuotationsForm extends Component {
  constructor(props) {
    super(props);
    // getCurrentUser parsea localStorage y devuelve un objeto nuevo en cada
    // llamada; se fija una sola vez para no regenerar props en cada render.
    this.currentUser = auth.getCurrentUser();
    this.state = {
      id: props.match.params.id,
      formData: {
        reasonId: null,
        description: ' ',
        userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : {},
        date: moment().format('L'),
        quotationId: props.match.params.id,
      },
      optionsSelect: {
        users: [],
        clients: [],
      },
      disabled: true,
      showModal: false,
      active: false,
      statusOrder: '',
      saleId: '',
      status: '',
      loading: false,
      modalPrefixFolioSale: false,
      openSuccess: false,
      views: [],
      showModalDown: false,
    };
  }

  async componentWillMount() {
    if (!auth.verifyLogin()) return false;
    let newQuotation = immutable.set(
      this.props.Quotations,
      'generalQuotation.userId',
      auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
    );
    newQuotation = immutable.set(
      newQuotation,
      'generalQuotation.assignedTo',
      auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
    );
    newQuotation = immutable.set(
      newQuotation,
      'generalQuotation.executive',
      auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
    );
    if (this.state.id !== 'create') {
      newQuotation = immutable.set(newQuotation, 'loading', true);
    }

    this.props.setState(newQuotation);

    if (this.state.id !== 'create') this.props.findById(this.state.id);

    const franchiseId = auth.getCurrentUser().franchiseId;
    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: franchiseId,
      },
    };
    this.getOptionsSelect(
      'users',
      process.env.REACT_APP_URL_API +
      '/api/users?filter=' +
      JSON.stringify(params),
      (option) => {
        return {
          label: option.firstName + ' ' + option.lastName,
          value: option.id,
        };
      },
    );

    this.getOptionsSelect(
      'reasons',
      process.env.REACT_APP_URL_API + '/api/reasons',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      },
    );

    this.getQuotation();
  }

  getQuotation = async () => {
    var _this = this;
    let actualOrdenGenerated = '';
    let actualSaleId = '';
    let actualStatus = '';

    if (this.state.id !== 'create') {
      let viewsResult = await feathers.service('views').find({
        query: {
          quotation: this.state.id,
        },
      });

      let eventPatched = async function (data) {
        if (data.quotation === _this.state.id) {
          let viewsResult = await feathers.service('views').find({
            query: {
              quotation: _this.state.id,
            },
          });
          _this.setState({
            views: viewsResult.data,
          });
        }
      };

      this.handleViewCreated = (data) => {
        if (data.quotation === _this.state.id) {
          _this.setState((prevState) => ({
            views: [...prevState.views, data],
          }));
        }
      };


      this.handleViewPatched = (data) => {
        if (data.quotation === _this.state.id) {
          _this.setState((prevState) => ({
            views: prevState.views.map((v) => (v._id === data._id ? data : v)),
          }));
        }
      };


      feathers.service('views').on('created', this.handleViewCreated);
      feathers.service('views').on('patched', this.handleViewPatched);

      axios
        .get(process.env.REACT_APP_URL_API + '/api/quotations/' + this.state.id)
        .then((res) => {
          actualOrdenGenerated = res.data.ordenGenerated;
          actualSaleId = res.data.saleId;
          actualStatus = res.data.status;
          this.setState({
            statusOrder: actualOrdenGenerated,
            saleId: actualSaleId,
            status: actualStatus,
            views: viewsResult.data,
          });
        });
    }
  };

  componentWillUnmount() {
    this.props.stateInit();
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    var response = await axios.get(url);
    var options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });
    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
      clients: response.data,
    });
  };

  onSubmit = ({ formData }) => {
    let _this = this;

    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password === null
    )
      delete formData.password;

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function () {
        _this.props.history.push('/admin/quotations');
      });
    } else {
      this.props.create(formData).then(function () {
        _this.props.history.push('/admin/quotations');
      });
    }
  };

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    var response = await axios.get(url);
    var options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });
    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  save = (status) => {
    let _this = this;

    if (!auth.getCurrentUser()) {
      auth.logout();
    }

    return new Promise(function (resolve, reject) {
      axios.patch(
        process.env.REACT_APP_URL_API +
        '/api/clients/' +
        _this.props.Quotations.clientInformation.id,
        {
          phone: _this.props.Quotations.clientInformation.phone,
          email: _this.props.Quotations.clientInformation.email,
          notes: _this.props.Quotations.clientInformation.notes,
        },
      );
      var newQuotationPost = {
        clientId: _this.props.Quotations.clientInformation.id,
        status,
        assignedTo: _this.props.Quotations.generalQuotation.assignedTo,
        generalQuotation: _this.props.Quotations.generalQuotation,
        dates: _this.props.Quotations.dates,
        messages: _this.props.Quotations.formDataMessages,
        lodgings: _this.props.Quotations.lodgings,
        flights: _this.props.Quotations.flights,
        otherServices: _this.props.Quotations.otherServicesQuotation,
        packages: _this.props.Quotations.packages,

        franchiseId: '42342342342342342432',
        franchiseNumber: auth.getCurrentUser().franchise.privateId,
      };
      if (status === 'sended') {
        newQuotationPost = immutable.set(
          newQuotationPost,
          'dateSended',
          moment(),
        );
      }
      //console.log('newQuotationPost', newQuotationPost);
      if (_this.state.id === 'create') {
        newQuotationPost.status = 'leats';
        newQuotationPost.ordenGenerated = false;
        axios
          .post(
            process.env.REACT_APP_URL_API + '/api/quotations',
            newQuotationPost,
          )
          .then(function (res) {
            _this.setState({
              id: res.data.id,
            });
            let newQuotation = immutable.set(
              _this.props.Quotations,
              'id',
              res.data.id,
            );
            _this.props.setState(newQuotation);
            _this.setState({
              id: res.data.id,
            });
            resolve(res);
          });
      } else {
        axios
          .patch(
            process.env.REACT_APP_URL_API + '/api/quotations/' + _this.state.id,
            newQuotationPost,
          )
          .then(function (res) {
            _this.setState({
              id: res.data.id,
            });
            resolve(res);
          });
      }
    });
  };

  handledCompleteForm = () => {
    if (this.formGeneral.reportValidity()) {
      let _this = this;
      this.setState({ loading: true });
      _this.save().then(function (res) {
        _this.props.history.push('/admin/quotations/' + res.data.id);
        _this.getQuotation();
        _this.handleSuccess(res);
      });
    }
  };

  handleSuccess = (res) => {
    if (res.status === 200) {
      this.setState({
        openSuccess: true,
        loading: false,
      });
    } else {
      //console.log('Error', res);
    }
  };

  onCloseModal = () => {
    this.setState({
      showModalDown: false,
      /*formData: {
        userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        date: moment().format('LLL'),
      },*/
    });
  };

  onCloseModalPrefixSale = () => {
    this.setState({
      modalPrefixFolioSale: false,
    });
  };

  onDown = async () => {
    this.setState({
      showModalDown: true,
    });
  };

  onChange = (path, value) => {
    const newObj = immutable.set(this.state.formData, path, value);
    this.setState({
      formData: newObj,
    });
  };

  onRedirect() {
    let _this = this;
    _this.props.history.push('/admin/clients/5b3cfe7f50fd1d0fd30f96e3');
  }

  confirmPrefixFolioSale = () => {
    if (this.formGeneral.reportValidity()) {
      this.setState({
        modalPrefixFolioSale: true,
      });
    }
  };

  selecPrefixFolioSale = (prefix) => {
    this.createSaleOrder(prefix);
  };

  onAdd = async () => {
    const updateDown = await feathers
      .service('quotations')
      .patch(this.state.id, {
        status: 'down',
      });

    const createFalling = await feathers
      .service('falling-quotes')
      .create(this.state.formData);

    if (updateDown._id && createFalling._id) {
      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
      this.props.history.push('/admin/quotations');
    }

    this.setState({
      showModalDown: false,
    });
  };

  createSaleOrder = async (prefix = 'VTA') => {
    try {
      const {
        clientInformation,
        flights,
        otherServicesQuotation,
        packages,
        lodgings,
        generalQuotation,
        dates,
        clientId,
      } = this.props.Quotations;

      axios.patch(
        process.env.REACT_APP_URL_API + '/api/quotations/' + this.state.id,
        { ordenGenerated: true },
      );

      const newFlights = flights.map((item) => {
        item.operator = item.operator.value;
        return item;
      });
      const newOtherServicesSale = otherServicesQuotation.map((item) => {
        item.operator = item.operator.value;
        return item;
      });
      const newOtherPackages = packages.map((item) => {
        item.operator = item.operator.value;
        return item;
      });
      const newLodging = lodgings.map((item) => {
        item.operator = item.operator.value;
        item.hotel = item.hotel.id;
        return item;
      });

      var newSalePost = {
        prefix: prefix,
        salesInformation: {
          statusId: prefix,
          destination: generalQuotation.destination,
          adults: generalQuotation.adults,
          juniors: generalQuotation.juniors,
          kids: generalQuotation.kids,
          notes: generalQuotation.notes,
          assignedTo: generalQuotation.assignedTo,
          down: false,
          // Se conservan en UTC: con moment() local la fecha se recorría un
          // día para usuarios fuera de UTC-6 y la venta quedaba mal guardada.
          departureDate: moment.utc(dates.departureDate).format(),
          returnDate: moment.utc(dates.returnDate).format(),
          interest: generalQuotation.interest,
          isPackage: generalQuotation.isPackage,
          trackingLine: generalQuotation.trackingLine,
        },
        balance: {
          totalPrice: 0,
          totalBuyPrice: 0,
          totalReceipt: 0,
          totalDebit: 0,
          payForm: 0,
          totalPayForm: 0,
          utility: 0,
          commissionsPercent: 10,
          commissions: 0,
          netProfit: 0,
        },
        files: [],
        flights: newFlights,
        otherServicesSale: newOtherServicesSale,
        packages: newOtherPackages,
        operatorsPaymentSale: [],
        lodging: newLodging,
        receipts: [],
        commissions: {},
        franchiseId: auth.getCurrentUser().franchise.id, //TODO cambiar
        franchiseNumber: 1,
        quotationId: this.props.match.params.id,
        assignedTo: generalQuotation.assignedTo,
        clientId: clientId,
        type: 'sale', // sale | invoice
      };

      var saleResult = await feathers.service('sales').create(newSalePost);

      axios.patch(
        process.env.REACT_APP_URL_API + '/api/quotations/' + this.state.id,
        { saleId: saleResult._id },
      );
      window.location.href = '/#/admin/sales/' + saleResult._id;
    } catch (err) {
      console.error(err);
      toast.error(
        'Revisa que hayas seleccionado un operador y un nombre de hotel.',
      );
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.remove(this.state.id).then(function () {
        _this.props.history.push('/admin/quotations');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  render() {
    let { history, Quotations } = this.props;
    const {
      id,
      optionsSelect,
      openSuccess,
      status,
      saleId,
      loading,
      showModalDown,
    } = this.state;

    const rolUser =
      auth.getCurrentUser() && auth.getCurrentUser().roles
        ? auth.getCurrentUser().roles
        : [];

    const ButtonsSave = () => (
      <div>
        {status !== 'down' ? (
          id !== 'create' ? (
            saleId === undefined || saleId === '' ? (
              <Button
                bsStyle="default"
                style={{ marginRight: 10 }}
                onClick={() => this.confirmPrefixFolioSale()}
                disabled={loading}
              >
                Generar orden de venta
              </Button>
            ) : (
              <Button
                bsStyle="default"
                style={{ marginRight: 10 }}
                onClick={() =>
                  (window.location.href = '/#/admin/sales/' + saleId)
                }
                disabled={loading}
              >
                Ver orden de venta
              </Button>
            )
          ) : null
        ) : null}

        {rolUser.includes('fallManager') &&
          id !== 'create' &&
          status !== 'down' ? (
          <Button
            bsStyle="primary"
            style={{ marginRight: 10 }}
            onClick={this.onDown}
            disabled={loading}
          >
            Caída
          </Button>
        ) : null}
        <Button
          bsStyle="primary"
          style={{ marginRight: 10 }}
          onClick={() => history.push('/admin/quotations')}
        >
          Regresar
        </Button>
        <ButtonSave
          onClick={this.handledCompleteForm}
          disabled={this.state.loading}
        />
        <button
          style={{ display: 'none' }}
          type="submit"
          ref={(ref) => {
            this.submitFormGeneral = ref;
          }}
        >
          Guardar
        </button>
      </div>
    );

    const MenuSaveBasic = () => (
      <Row>
        <Col lg={12}>
          <div
            className={'pull-right'}
            style={{
              marginBottom: 15,
            }}
          >
            <ButtonsSave />
          </div>
        </Col>
      </Row>
    );

    const MenuSaveSticky = (props) => {
      return (
        <div
          style={{
            background: '#f6f5f6',
            textAlign: 'right',
            padding: '15px 10px 15px 0px',
            borderBottom: '1px solid #e1e1e1',
          }}
        >
          <ButtonsSave />
        </div>
      );
    };

    const ModalVerifySaleCreate = () => (
      <Modal
        open={this.state.modalPrefixFolioSale}
        onClose={this.onCloseModalPrefixSale}
        styles={{
          modal: { width: '100%' },
          overlay: { alignItems: 'flex-start' },
        }}
        closeOnOverlayClick={false}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
              <h5>Tipo de nota de venta</h5>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button
                bsStyle="primary"
                fill
                onClick={() => this.selecPrefixFolioSale('VTA')}
              >
                Nota de venta sin factura
              </Button>{' '}
              {'  '}
              <Button
                bsStyle="primary"
                fill
                onClick={() => this.selecPrefixFolioSale('F')}
              >
                Nota de venta con factura
              </Button>
            </Col>
          </Row>
        </Grid>
      </Modal>
    );

    return this.props.Quotations.loading ? (
      <Loading />
    ) : (
      <StickyContainer className="main-content">
        <ModalVerifySaleCreate />
        <Modal
          open={showModalDown}
          onClose={this.onCloseModal}
          styles={{
            modal: { width: '100%' },
            overlay: { alignItems: 'flex-start' },
          }}
          closeOnOverlayClick={false}
        >
          <form
            ref={(ref) => {
              this.formFalling = ref;
            }}
          >
            <div>
              <Grid fluid>
                <Row>
                  <Col md={12}>
                    <h5>Cotización caída</h5>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        htmlFor="responsable"
                        style={{ fontWeight: '400' }}
                      >
                        Responsable
                      </label>
                      <Select
                        placeholder="-- Seleccionar"
                        name="userId"
                        value={this.state.formData.userId}
                        options={optionsSelect.users}
                        onChange={(event) =>
                          this.onChange('userId', event.value)
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="date" style={{ fontWeight: '400' }}>
                        Fecha
                      </label>
                      <input
                        id="date"
                        className="form-control"
                        value={this.state.formData.date}
                        onChange={(event) =>
                          this.onChange('date', event.target.value)
                        }
                        name="date"
                        type="string"
                        disabled={this.state.disabled}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="reasonId" style={{ fontWeight: '400' }}>
                        Causa
                      </label>
                      <Select
                        required
                        placeholder="-- Seleccionar"
                        name="reasonId"
                        value={this.state.formData.reasonId}
                        options={optionsSelect.reasons}
                        onChange={(event) =>
                          this.onChange('reasonId', event.value)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        htmlFor="description"
                        style={{ fontWeight: '400' }}
                      >
                        Descripción
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="description"
                        name="description"
                        value={this.state.formData.description}
                        onChange={(event) =>
                          this.onChange('description', event.target.value)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className={'pull-right'} style={{ marginBottom: 15 }}>
                      <Button
                        bsStyle="primary"
                        style={{ marginRight: 10 }}
                        onClick={this.onCloseModal}
                      >
                        Regresar
                      </Button>
                      <Button bsStyle="primary" fill onClick={this.onAdd}>
                        Guardar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </div>
          </form>
        </Modal>
        <Grid fluid>
          {openSuccess && (
            <SweetAlert
              success
              style={{ display: 'block', marginTop: '-100px' }}
              title="Se ha guardado correctamente!"
              confirmBtnBsStyle="info"
              onConfirm={() => window.location.reload()}
            >
              No olvides enviar la cotización al cliente!
            </SweetAlert>
          )}
          <form
            ref={(ref) => {
              this.formGeneral = ref;
            }}
            // onSubmit={this.handledCompleteForm}
            id="Quotation"
          >
            <Sticky>
              {({ style, isSticky }) => (
                <div style={{ ...style, zIndex: 1000 }}>
                  {isSticky ? <MenuSaveSticky /> : <MenuSaveBasic />}
                </div>
              )}
            </Sticky>

            <Row>
              <Col lg={4}>
                <Card
                  title={<legend>Información del Cliente</legend>}
                  content={
                    <div>
                      <ClientInformation onSubmit={this.save} {...this.props} />
                    </div>
                  }
                />

                <Card
                  title={<legend>Visitas</legend>}
                  content={
                    <div>
                      {this.state.views.map((view, index) => {
                        return (
                          <div key={index}>
                            <Row>
                              <Col md={12}>
                                {view.end !== undefined ? (
                                  <div>
                                    <Row>
                                      <Col md={6}>
                                        {moment(view.end).diff(
                                          view.start,
                                          'seconds',
                                        ) < 60 ? (
                                          <Badge
                                            style={{
                                              fontSize: '14px',
                                              background: '#1dacd6',
                                              marginBottom: '5px',
                                            }}
                                          >
                                            {moment(view.end).diff(
                                              view.start,
                                              'seconds',
                                            )}{' '}
                                            SEGUNDOS
                                          </Badge>
                                        ) : (
                                          moment(view.end).diff(
                                            view.start,
                                            'minutes',
                                          ) < 60 && (
                                            <Badge
                                              style={{
                                                fontSize: '14px',
                                                background: '#1dacd6',
                                                marginBottom: '5px',
                                              }}
                                            >
                                              {moment(view.end).diff(
                                                view.start,
                                                'minutes',
                                              )}{' '}
                                              MINUTOS
                                            </Badge>
                                          )
                                        )}
                                        {moment(view.end).diff(
                                          view.start,
                                          'hours',
                                        ) === 1 && (
                                            <Badge
                                              style={{
                                                fontSize: '14px',
                                                background: '#1dacd6',
                                                marginBottom: '5px',
                                              }}
                                            >
                                              {moment(view.end).diff(
                                                view.start,
                                                'hours',
                                              )}{' '}
                                              HORA
                                            </Badge>
                                          )}
                                        {moment(view.end).diff(
                                          view.start,
                                          'hours',
                                        ) > 1 && (
                                            <Badge
                                              style={{
                                                fontSize: '14px',
                                                background: '#1dacd6',
                                                marginBottom: '5px',
                                              }}
                                            >
                                              {moment(view.end).diff(
                                                view.start,
                                                'hours',
                                              )}{' '}
                                              HORAS
                                            </Badge>
                                          )}
                                      </Col>
                                      <Col md={6}>
                                        <strong>
                                          {' '}
                                          {moment(view.start).format('llll')}
                                        </strong>
                                      </Col>
                                    </Row>
                                  </div>
                                ) : (
                                  <div>
                                    <Badge
                                      style={{
                                        fontSize: '14px',
                                        background: '#71af0a',
                                        marginBottom: '5px',
                                      }}
                                    >
                                      ¡VIENDO AHORA!
                                    </Badge>
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                    </div>
                  }
                />
              </Col>
              {Quotations.clientInformation.id !== undefined ? (
                <Col lg={8}>
                  <Card
                    title={
                      this.state.id === 'create' ? (
                        <legend>Nueva Cotización</legend>
                      ) : (
                        <legend>
                          Cotización <strong>{Quotations.folio}</strong>
                        </legend>
                      )
                    }
                    content={
                      <div>
                        <GeneralQuotation />
                      </div>
                    }
                  />
                  <Card
                    title={<legend>Fechas</legend>}
                    content={
                      <div>
                        <DatesQuotation />
                      </div>
                    }
                  />
                  <Card
                    title={<legend>Vuelos</legend>}
                    content={
                      <div>
                        <FlightQuotation />
                        <FlightQuotationAdd />
                      </div>
                    }
                  />
                  <Card
                    title={<legend>Hospedaje</legend>}
                    content={
                      <div>
                        <LodgingQuotation />
                        <LodgingQuotationAdd user={this.currentUser} />
                      </div>
                    }
                  />
                  <Card
                    title={<legend>Otros Servicios</legend>}
                    content={
                      <div>
                        <OtherServicesQuotation />
                        <OtherServicesQuotationAdd />
                      </div>
                    }
                  />
                  <Card
                    title={<legend>Paquetes</legend>}
                    content={
                      <div>
                        <Packages />
                        <PackagesAdd />
                      </div>
                    }
                  />
                </Col>
              ) : null}

              {/* //DONE Toño - Crear el total de acuerdo a los "Me Interesa"  */}
            </Row>
          </form>
        </Grid>
      </StickyContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Quotations: state.Quotations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(QuotationsActions, dispatch);
};

const QuotationsConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuotationsForm);

export default QuotationsConnect;



// WEBPACK FOOTER //
// ./src/views/Quotations/QuotationsForm.jsx